import React from 'react'
import propTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Field, FieldArray } from 'formik'
import get from 'lodash/get'
import startCase from 'lodash/startCase'

import RepeatableAction from '../RepeatableAction'
import { Dropdown } from '../Autocomplete'
import Input from '../Input'

const PhoneFields = ({
  form,
  name,
  label,
  phoneNotRepeating,
  inputProps,
  staticData
}) => {
  let phones = get(form.values, name)
  if (phones.length === 0) {
    phones = [{ phoneTypeId: null, phoneNum: '' }]
  }

  const expert = get(form.values, 'expert')

  return (
    <>
      {renderExpertPhone(staticData, expert)}

      <div className='expert-form__input-group'>
        <label className='expert-form__label'>{label}</label>
        <div className='expert-form__input-wrapper'>
          <FieldArray
            name={name}
            render={arrayHelpers => (
              <div className='expert-form__repeatable-input-wrapper'>
                {phones.map((phone, index) => (
                  <div
                    className='expert-form__repeatable-input expert-form__repeatable-input--multiple'
                    key={index}
                  >
                    <Field
                      name={`${name}[${index}].phoneTypeId`}
                      placeholder='Select type'
                      itemToString={item => item && item.name}
                      options={staticData.phoneTypes}
                      component={Dropdown}
                    />
                    <Field
                      name={`${name}[${index}].phoneNum`}
                      component={Input}
                      {...inputProps}
                    />
                    <RepeatableAction
                      fieldValues={phones}
                      arrayHelpers={arrayHelpers}
                      index={index}
                      initialObject={{ phoneTypeId: null, phoneNum: '' }}
                    />
                  </div>
                ))}
              </div>
            )}
          />
          {phoneNotRepeating ? (
            <div className='expert-form__input-error'>{phoneNotRepeating}</div>
          ) : null}
        </div>
      </div>
    </>
  )
}

const renderExpertPhone = (staticData, expert) => {
  if (!expert) return null
  if (expert.phoneTypeId !== staticData.CONST.PHONE_TYPES.MOBILE) {
    return null
  }

  const phoneType = staticData.phoneTypes.find(item => {
    return expert.phoneTypeId === item.id
  })

  let label = startCase(get(phoneType, 'name', 'not specified'))

  return (
    <div className='expert-form__input-group'>
      <label className='expert-form__label'>{`${label} (added by expert)`}</label>
      <div className='expert-form__input-wrapper'>
        <div className='expert-form__repeatable-input-wrapper'>
          <div className='expert-form__repeatable-input expert-form__repeatable-input--multiple'>
            <Field
              name={`expert.phoneTypeId`}
              placeholder='Select type'
              itemToString={item => item && item.name}
              options={staticData.phoneTypes}
              component={Dropdown}
              disabled
            />
            <Field name={`expert.phoneNum`} component={Input} disabled />
          </div>
        </div>
      </div>
    </div>
  )
}

PhoneFields.propTypes = {
  form: propTypes.object.isRequired,
  name: propTypes.string.isRequired,
  label: propTypes.oneOfType([propTypes.string, propTypes.element]),
  phoneNotRepeating: propTypes.string,
  inputProps: propTypes.object,
  staticData: propTypes.object,
  expert: propTypes.object
}

export default inject('staticData')(observer(PhoneFields))
